"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isOrisalesAvailable = void 0;
var _globalApiClientReact = require("@ori/global-api-client-react");
const isOrisalesAvailable = userType => userType === _globalApiClientReact.GlobalApplicationsPersonalMenuPersonalMenuDtoUserType.Consultant;
exports.isOrisalesAvailable = isOrisalesAvailable;